import { DOCUMENT } from '@angular/common';
import { Directive, Inject, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

import animateScrollTo from 'animated-scroll-to';

import { BasicObject } from '../models/services.interface';

@Directive({
    selector: '[checkoutScrollTo]',
    standalone: true,
})
export class ScrollToDirective implements OnInit, OnChanges {
    /**
     * [Input DOM element used to scroll to]
     * @return {[type]} [description]
     */
    @Input()
    public domId: string;
    @Input()
    public triggerInitialScroll: boolean = false; // Scroll on page load if the element to scroll to is in the dom
    @Input()
    public enableScroll: boolean = false;
    @Input()
    public targetFallback: string = '';
    @Input()
    public elementToScroll: HTMLElement;

    private scrollOptions: BasicObject = {
        speed: 500,
        minDuration: 250,
        maxDuration: 3000,
        cancelOnUserAction: true,
    };

    constructor(@Inject(DOCUMENT) private document: any) {}

    public ngOnInit(): void {
        this.scrollOptions.elementToScroll = this.elementToScroll || window;
        if (this.triggerInitialScroll) {
            this._scrollToTarget();
        }
    }

    public ngOnChanges(changes: SimpleChanges): void {
        if (!!changes.enableScroll.currentValue) {
            this._scrollToTarget();
        }
    }

    /**
     *
     * Scroll to defined target
     * @private
     * @memberof ScrollToDirective
     */
    private _scrollToTarget(): void {
        const target: Element =
            this.document.defaultView.document.querySelector(`#${this.domId}`) ||
            this.document.defaultView.document.querySelector(`.${this.domId}`);
        let offset: number = 0;

        if (target) {
            offset = (target as HTMLElement).offsetTop;
        }

        if (this.targetFallback) {
            const targetFallback: Element =
                this.document.defaultView.document.querySelector(`#${this.targetFallback}`) ||
                this.document.defaultView.document.querySelector(`.${this.targetFallback}`);

            if (!offset && targetFallback) {
                offset = (targetFallback as HTMLElement).offsetTop;
            }
        }
        animateScrollTo(offset, this.scrollOptions);
    }
}
